import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setStationSearchText, stationSearchTextSelector } from '../filtersSlice';

/** хук берет и работает с данными из `filterSlice` по вводимому поисковому тексту по станциям */
export const useStationSearchText = () => {
  const dispatch = useDispatch();
  const searchText = useSelector(stationSearchTextSelector);

  const onChangeSearchText = React.useCallback((text: string) => {
    dispatch(setStationSearchText(text));
  }, [dispatch]);
  return {
    searchText,
    onChangeSearchText,
  };
};
